import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      navigate("/login", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } })
      .then((r) => {
        setUser(r.data);
        navigate("/account", { replace: true, state: { user: r.data } });
      })
      .catch(() => navigate("/login", { replace: true }));
  }, [location, navigate, setUser]);

  return (
    <div className="flex min-h-screen items-center justify-center" data-testid="auth-callback">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-neutral-500">
        Completing sign-in…
      </p>
    </div>
  );
}
